import { ArrowLeft, HelpCircle, Home, LogOut, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import koinRemitLogo from '../assets/koinremit-logo.png';
import { getLoginIdentity } from '../services/authStorage';

export default function PortalHeader({
  user,
  onLogout,
  onBack,
  backLabel = 'Back',
  showHelp = false,
  showHome = false,
  children,
}) {
  const identity = getLoginIdentity()?.value || user?.email || user?.username || localStorage.getItem('user_email');
  const homeTarget = localStorage.getItem('token') ? '/' : '/login';

  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2">
        <div className="flex min-w-0 items-center gap-2 sm:gap-4">
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label={backLabel}
              className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded text-slate-600 hover:bg-slate-100 hover:text-slate-900"
            >
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            </button>
          ) : null}
          <Link to={homeTarget} aria-label="Koin Remit home" className="shrink-0">
            <img src={koinRemitLogo} alt="Koin Remit" className="h-12 w-auto" />
          </Link>
        </div>
        <div className="flex min-w-0 items-center gap-1 sm:gap-2">
          {showHelp ? (
            <Link
              to="/howitworks"
              aria-label="How Koin Remit works"
              className="inline-flex h-9 items-center gap-2 rounded px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 hover:text-slate-900 sm:px-3"
            >
              <HelpCircle className="h-4 w-4" aria-hidden="true" />
              <span className="hidden sm:inline">How It Works</span>
            </Link>
          ) : null}
          {showHome ? (
            <Link
              to={homeTarget}
              aria-label="Home"
              className="inline-flex h-9 items-center gap-2 rounded px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 hover:text-slate-900 sm:px-3"
            >
              <Home className="h-4 w-4" aria-hidden="true" />
              <span className="hidden sm:inline">Home</span>
            </Link>
          ) : null}
          {children}
          {identity ? (
            <Link to="/?tab=settings#profile" aria-label="Profile"
              className="flex h-9 w-9 items-center justify-center gap-2 rounded text-sm text-slate-600 hover:bg-slate-100 hover:text-slate-900 sm:w-auto sm:px-2">
              <User className="h-4 w-4" aria-hidden="true" />
              <span className="hidden max-w-52 truncate font-medium sm:inline">{identity}</span>
            </Link>
          ) : null}
          {onLogout ? (
            <button type="button" onClick={onLogout}
              aria-label="Log out"
              className="flex items-center gap-2 rounded px-2 py-2 text-sm text-slate-600 hover:bg-slate-100 hover:text-slate-900 sm:px-3">
              <LogOut className="h-4 w-4" aria-hidden="true" />
              <span>Logout</span>
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}
